import { CONTACT_EMAIL, LINKEDIN_URL } from "../../data/pwt";
import { Linkedin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A140F] text-white/60 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <a
          href="#top"
          aria-label="PWT — Performance With Trust"
          className="inline-flex items-center"
          data-testid="footer-logo"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_pwt-solutions-1/artifacts/p6xipp7j_PWT_Colori_positivo_orizzontale.png"
            alt="PWT — Performance With Trust"
            className="h-8 md:h-9 w-auto"
            style={{ filter: "brightness(0) invert(1)" }}
            draggable={false}
          />
        </a>
        <div className="font-mono text-xs tracking-widest uppercase">
          © {year} PWT · All rights reserved
        </div>
        <div className="flex items-center gap-6">
          <a
            data-testid="footer-email-link"
            href={`mailto:${CONTACT_EMAIL}`}
            className="font-sans text-sm text-white/70 hover:text-white transition-colors"
          >
            {CONTACT_EMAIL}
          </a>
          <a
            data-testid="footer-linkedin-link"
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="PWT on LinkedIn"
            className="text-white/70 hover:text-white transition-colors"
          >
            <Linkedin size={18} strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </footer>
  );
}
